import * as React from "react";
import Projects from "./Projects";
import Landing from "./Landing";

export default function Content({
  projectsVisable,
  setProjectsVisable,
  wrangledProjects,
  setContactFormIsOpen,
  setContactFormMessage,
  appWrappedTranslator,
}) {
  return (
    <div id="appContent">
      {!projectsVisable && (
        <Landing
          projectsVisable={projectsVisable}
          setProjectsVisable={setProjectsVisable}
          appWrappedTranslator={appWrappedTranslator}
        />
      )}
      {projectsVisable && (
        <div id="projectsContainer">
          <Projects
            wrangledProjects={wrangledProjects}
            setContactFormIsOpen={setContactFormIsOpen}
            setContactFormMessage={setContactFormMessage}
            appWrappedTranslator={appWrappedTranslator}
          />
        </div>
      )}
    </div>
  );
}
